import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { serverFetch } from "@core/server";
import { setDialogUnreadQty } from "../../store/dialog-unread-slice";
import dialogSignalRService from "../../services/dialogSignalRService";

const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

const DialogUnreadListener = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.user.session);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!session) {
      dispatch(setDialogUnreadQty(0));
      return undefined;
    }

    const canDialogs = getLawFlag(session.law, 110) === 1;
    const sessionId = session.sessionId || localStorage.getItem("sessionId");

    const loadQty = () => {
      if (!canDialogs) {
        dispatch(setDialogUnreadQty(0));
        return;
      }
      serverFetch("Message/Dialog/UnreadQty")
        .then((data) => {
          dispatch(setDialogUnreadQty(data?.qty ?? data?.Qty ?? 0));
        })
        .catch(() => {
          dispatch(setDialogUnreadQty(0));
        });
    };

    loadQty();

    const scheduleLoad = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(loadQty, 250);
    };

    const offReceive = dialogSignalRService.onReceive(scheduleLoad);

    if (sessionId) {
      dialogSignalRService.joinCompany(sessionId).catch(() => {});
    }

    return () => {
      clearTimeout(timerRef.current);
      offReceive();
    };
  }, [dispatch, session]);

  return null;
};

export default DialogUnreadListener;
